module.exports = __webpack_public_path__ + "img/1.b64cd990.jpeg";